/**
 * Lightweight class name combiner to avoid adding a dependency.
 * Filters falsy values and joins with spaces.
 */
export function cn(...classNameParts: Array<string | undefined | null | false>): string {
  return classNameParts.filter(Boolean).join(' ');
}
